export default "__VITE_ASSET__Df_pWBh1__"